// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33l3D","field":"styles_field__37VHD","fieldCol":"styles_fieldCol__317Wo","diffCol":"styles_diffCol__3y9dj","diff":"styles_diff__1ktsb"};